const PROVIDER_LABELS = {
  apple_health: "Apple Health",
  health_connect: "Google Health Connect",
  strava: "Strava",
  fitbit: "Fitbit",
  garmin: "Garmin",
};

export const FITBIT_CONNECTION_CUTOFF_MS = Date.parse("2026-10-30T00:00:00Z");

export function hasFitbitConnectionEnded(now = Date.now()) {
  return now >= FITBIT_CONNECTION_CUTOFF_MS;
}

function normalizeProvider(provider) {
  if (typeof provider !== "string") return null;
  const normalized = provider.trim().toLowerCase().replace(/[\s-]+/g, "_");
  return PROVIDER_LABELS[normalized] ? normalized : null;
}

export function getLegacyLinkedDevice(userData) {
  if (!userData) return "none";

  // Health Connect can coexist with retained Fitbit data after migration.
  if (userData.healthConnectConnected === true) return "Google Health Connect";

  // Preserve the existing precedence for the other legacy connections.
  if (userData.garminAccount) return "Garmin";
  if (userData.fitbitAccount) return "Fitbit";
  if (userData.stravaAccount) return "Strava";
  if (userData.appleHealthConnected === true) return "Apple Health";
  return "none";
}

export function getLinkedDevice(integrationData, userData) {
  if (integrationData?.status === "connected") {
    const provider = normalizeProvider(integrationData.provider);
    if (provider) return PROVIDER_LABELS[provider];
  }

  if (integrationData?.status === "disconnected" &&
      normalizeProvider(integrationData.provider) === "health_connect") {
    return getLegacyLinkedDevice({ ...userData, healthConnectConnected: false });
  }

  return getLegacyLinkedDevice(userData);
}

export function getActivityProvider(entry) {
  const explicitProvider = normalizeProvider(
    entry?.value?.provider || entry?.value?.activity?.provider
  );
  if (explicitProvider) return explicitProvider;

  const eventId = typeof entry?.key === "string" ? entry.key : "";
  if (/^AppleHealth/.test(eventId)) return "apple_health";
  if (/^Fit_/.test(eventId)) return "fitbit";
  if (/^S_/.test(eventId)) return "strava";
  if (/^Garmin_/.test(eventId)) return "garmin";
  return null;
}

export function getProviderLabel(provider) {
  return PROVIDER_LABELS[provider] || null;
}
